import { render, staticRenderFns } from "./TrainingCitiesList.vue?vue&type=template&id=d5b67224&"
import script from "./TrainingCitiesList.vue?vue&type=script&lang=js&"
export * from "./TrainingCitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports